/**
 * External destinations shared across surfaces.
 *
 * The Discord invite previously lived as a local constant inside
 * `FoundingSquad.tsx`. Now that the CTA band and the coming-soon page
 * (via `PreLaunchActions`) both offer it, one definition prevents multiple
 * copies disagreeing.
 */

export const DISCORD_INVITE_URL = 'https://discord.gg/8geCpSu767'

/**
 * Android availability. `url: null` renders informational text rather than a
 * link, so the button never lands on a Play Store 404. `PreLaunchActions`
 * only renders the Play Store link when BOTH `available` is `true` AND `url`
 * is non-null — set both fields here when a listing exists, no component
 * changes needed.
 */
export const ANDROID_STATUS: { available: boolean; url: string | null } = {
  available: false,
  url: null,
}
